import { useState, useEffect, useCallback } from "react";
import { a as isWindowDefined } from "./index-BYSTnSKO.js";
import { e as TEST_MODE_QUERY_PARAM } from "./index-BIblv54e.js";
import { g as getEnvVariable } from "./index-C9TrZnbr.js";
const useIsTestMode = () => {
  const [isTestMode, setIsTestMode] = useState(false);
  useEffect(() => {
    if (!isWindowDefined()) return;
    const windowParams = new URL(window.location.href).searchParams;
    setIsTestMode(windowParams.has(TEST_MODE_QUERY_PARAM) && Boolean(windowParams.get(TEST_MODE_QUERY_PARAM)));
  }, []);
  return isTestMode;
};
const useFetchOffers = ({ environment = "production" }) => {
  const [offers, setOffers] = useState([]);
  const [offersError, setOffersError] = useState(null);
  const [offersSuccess, setOffersSuccess] = useState(false);
  const fetchOffers = useCallback(async (signal) => {
    try {
      const offersAPI = getEnvVariable({
        currentEnv: environment,
        keyToSearch: "GET_OFFERS_API"
      });
      const res = await window.fetch(offersAPI, { signal });
      if (!res.ok) throw new Error(`Error: ${res.statusText}`);
      const response = await res.json();
      setOffers((response == null ? void 0 : response.offers) ?? []);
      setOffersSuccess(true);
    } catch (err) {
      setOffersError(err.message);
      console.error("Something went wrong getting the offers:", { err });
    }
  }, [environment]);
  useEffect(() => {
    if (!isWindowDefined()) return;
    const controller = new AbortController();
    const signal = controller.signal;
    fetchOffers(signal);
    return () => controller.abort();
  }, [fetchOffers]);
  return { offers, offersError, offersSuccess };
};
const isEventListenerAvailable = () => isWindowDefined() && (window == null ? void 0 : window.ql_dl) && typeof window.ql_dl.addEventListener === "function";
const useMarketingClickId = () => {
  const [marketingClickId, setMarketingClickId] = useState(null);
  const [marketingClickError, setMarketingClickError] = useState(null);
  const [marketingClickSuccess, setMarketingClickSuccess] = useState(false);
  useEffect(() => {
    if (!isEventListenerAvailable()) {
      console.warn("ql_dl is not available or does not support event listeners.");
      return;
    }
    const handleEvent = (event) => {
      var _a;
      setMarketingClickId(((_a = event == null ? void 0 : event.user) == null ? void 0 : _a.marketingClickId) ?? "");
      setMarketingClickSuccess(true);
    };
    try {
      window.ql_dl.addEventListener(handleEvent);
    } catch (err) {
      setMarketingClickError(err.message);
      console.error("Something went wrong adding the event listener:", { err });
    }
    return () => {
      if (isEventListenerAvailable() && typeof window.ql_dl.removeEventListener === "function") {
        window.ql_dl.removeEventListener(handleEvent);
      }
    };
  }, []);
  return { marketingClickSuccess, marketingClickError, marketingClickId };
};
export {
  useIsTestMode as a,
  useMarketingClickId as b,
  useFetchOffers as u
};
//# sourceMappingURL=useMarketingClickId-N3aoPnYp.js.map
